/**
 * @file
 * Pasar Theme behaviors.
 */
(function (Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.customVideoControl = {
    attach: function (context, settings) {
      // Ensure this code only runs once per context
      once('custom-video-control', '.video-wrapper', context).forEach(function (wrapper) {
        var video = wrapper.querySelector('video');
        var button = wrapper.querySelector('button');

        if (video && button) {

          function updateButtonVisibility() {
            if (video.paused) {
              button.classList.toggle("active");
            } else {
              button.classList.toggle("active");
            }
          }

          button.addEventListener('click', function() {
            if (button.classList.contains("active")) {
              video.play();
            } else {
              video.pause();
            }
          });

          // Update button visibility on video play/pause events
          video.addEventListener('play', updateButtonVisibility);
          video.addEventListener('pause', updateButtonVisibility);
        }
      });
    }
  };

  Drupal.behaviors.tableGradientScroll = {
    attach: function (context, settings) {
      const tables = context.querySelectorAll('table');

      tables.forEach(function (table) {
        const tableWrapper = table.closest('.field--name-field-cb-table');
        if (!tableWrapper) return; // Ensure there's a wrapper to apply the gradients

        let isDragging = false;
        let dragTimeout;

        const updateGradients = () => {
          // Measure scroll values on the table element
          const scrollLeft = table.scrollLeft;
          const scrollWidth = table.scrollWidth;
          const clientWidth = table.clientWidth;

          if (scrollLeft === 0) {
            // At the start
            tableWrapper.classList.add('scrolled-start');
            tableWrapper.classList.remove('scrolled-middle', 'scrolled-end');
          } else if (scrollLeft + clientWidth >= scrollWidth - 1) {
            // At the end
            tableWrapper.classList.add('scrolled-end');
            tableWrapper.classList.remove('scrolled-start', 'scrolled-middle');
          } else {
            // In the middle
            tableWrapper.classList.add('scrolled-middle');
            tableWrapper.classList.remove('scrolled-start', 'scrolled-end');
          }
        };

        // Initial check on page load
        updateGradients();

        // Update on scroll
        table.addEventListener('scroll', updateGradients);

        // Start tracking dragging
        table.addEventListener('pointerdown', function () {
          isDragging = true;
        });

        // Handle dragging movement
        table.addEventListener('pointermove', function () {
          if (isDragging) {
            clearTimeout(dragTimeout);
            dragTimeout = setTimeout(() => {
              updateGradients();
            }, 10); // Delay to ensure scroll position is captured
          }
        });

        // Stop tracking dragging
        table.addEventListener('pointerup', function () {
          isDragging = false;
        });

        // Handle when pointer leaves the element (in case of dragging outside)
        table.addEventListener('pointerleave', function () {
          isDragging = false;
        });

        // Update on window resize
        window.addEventListener('resize', updateGradients);
      });
    }
  };

} (Drupal, drupalSettings, once));
